<div class="wrapper" *ngIf="displayLanguage">
    <div class="badge rounded-pill custom-badge">
        <app-icon type="Globe"></app-icon>
        <span class="text">
            {{ displayText }} <em class="es">{{ displayLanguage }}</em>
        </span>
    </div>
</div>
